import {
  DroneComparison,
  DroneFAQ,
  DroneHowTo,
  DroneInfo,
  TreebulaReviews,
  QuoteSlider,
  TreebulaStudio,
} from "./sections";
import { TailwindWrapper } from "../../../TailwindWrapper/TailwindWrapper";

const DroneLandingPage = () => {
  return (
    <div className="container-fluid p-0">
      <TailwindWrapper>
        <DroneInfo />
        <DroneHowTo />
        <TreebulaStudio />
        <DroneComparison />
        <TreebulaReviews />
        <QuoteSlider />
        <DroneFAQ />
      </TailwindWrapper>
    </div>
  );
};

export default DroneLandingPage;
